// Format values to display in the UI.
import countryList from 'react-select-country-list'

export const dateFormat = 'MMMM DD, YYYY'

export const formatAddress = address => {
  // Return a string with the address formatted for display.
  if (address) {
    const addr2 = address.line2Value ? `, ${address.line2Value}` : ''
    const street = `${address.line1Value}${addr2}`.trim()
    const city = address.cityValue ? `${address.cityValue},` : ''
    let countryName = ''
    if (
      address.countryValue &&
      !['United States', 'US', ''].includes(address.countryValue)
    ) {
      countryName = countryList().getLabel(address.countryValue)
    }

    return `${street}
${city} ${address.stateValue}  ${address.zipValue}
${countryName}`.trim()
  } else {
    return ''
  }
}

export const formatBoolean = flag => {
  // Return a string of Yes if flag is true, No if not.
  return flag ? 'Yes' : 'No'
}

export const formatDateString = (date, format = 'MDY') => {
  // Input date is a string in format YYYY-MM-DD.
  // Return a string in the given format.
  let result = '-'
  if (date) {
    const res = date.split('-')
    if (res.length == 3) {
      const year = res[0]
      const month = res[1]
      const day = res[2]
      switch (format) {
        case 'DMY':
          result = `${day}/${month}/${year}`
          break
        case 'MDY':
        default:
          result = `${month}/${day}/${year}`
      }
    }
  }
  return result
}

export const formatYesNoToTrueFalse = flag => {
  //Return a string of True if flag is Yes, False if not.
  return flag && flag.toUpperCase() === 'YES' ? 'True' : 'False'
}

export const formatPersonName = (first, middle, last, suffix) => {
  // Return a string with the person's name, formatted for display.
  return `${first ? first : ''} ${middle ? middle : ''} ${last ? last : ''} ${
    suffix ? suffix : ''
  }`.trim()
}

export const formatAttachedFiles = files => {
  return files && files.map(file => file.file.name).join(', ')
}

export const formatReviewString = val => {
  const exists = val != null
  const notEmptyString = exists && val.length > 0
  return exists && notEmptyString ? val : '-'
}

export const formatHeight = (value, unit) =>
  unit === 'metric'
    ? `${value} centimeters`
    : `${Math.floor(value / 12)} feet ${value % 12} inches`

export const formatWeight = (value, unit) =>
  unit === 'metric' ? `${value} kilograms` : `${value} pounds`
